
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './tracking';
import { NAVIGATION_LOGS } from './constants';

export const usePageTracking = () => {
  const location = useLocation();
  const startTimeRef = useRef<number>(Date.now());
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    const now = Date.now();

    if (previousPathRef.current) {
      const duration = now - startTimeRef.current;

      trackPageView(previousPathRef.current, duration);
    }

    startTimeRef.current = now;
    previousPathRef.current = location.pathname;

  }, [location.pathname]);

  useEffect(() => {
    const handleUnload = () => {
      if (previousPathRef.current) {
        const duration = Date.now() - startTimeRef.current;

        navigator.sendBeacon(
         NAVIGATION_LOGS,
          JSON.stringify({
            type: 'NAVIGATION',
            action: 'PAGE_EXIT',
            page: previousPathRef.current,
            duration,
            sessionId: sessionStorage.getItem('session_id'),
            timestamp: new Date().toISOString(),
          })
        );
      }
    };

    window.addEventListener('beforeunload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);
};